// externals
import type { Reducer } from 'redux';

// libraries
import type { DealLifecycle } from '@makemydeal/dr-dash-bff-types';
import type { DealLifecycle as DealLifecycleState } from '@makemydeal/dr-dash-types';
import { UpdateDealLifecycleStatus } from '@makemydeal/dr-dash-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { dateUtils } from '@makemydeal/dr-common-utils';

// consts/enums
import {
    SET_DEAL_LIFE_CYCLE_MODAL_LOADER,
    SHOW_DEAL_LIFE_CYCLE_MODAL,
    UPDATE_DEAL_LIFE_CYCLE_FAILURE,
    UPDATE_DEAL_LIFE_CYCLE_READY,
    UPDATE_DEAL_LIFE_CYCLE_REQUEST,
    UPDATE_DEAL_LIFE_CYCLE_SUCCESS
} from '../actionTypes/dealLifeCycleActionTypes';
import { SOCKET_EVENT_RECEIVED } from '../actionTypes/socketActionTypes';

const { INIT_PENCIL_SUCCESS } = initActionTypes;

export type DealLifecycleReducer = Reducer<DealLifecycle>;

export const UPDATE_DEAL_LIFECYCLE_INITIAL_STATE: DealLifecycleState = {
    showDealLifeCycleModal: false,
    updateDealLifecycleStatus: UpdateDealLifecycleStatus.Ready,
    showDealLifeCycleModalLoader: false,
    hasContractSignDateUpdated: false
};

export const reducer: DealLifecycleReducer = (state: Partial<DealLifecycle> = UPDATE_DEAL_LIFECYCLE_INITIAL_STATE, action: any) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...(action.payload.dealLifecycle || {})
            };
        }

        case UPDATE_DEAL_LIFE_CYCLE_SUCCESS: {
            const { enableDealLifeCycleUpdates, ...restPayload } = action.payload;
            return {
                ...state,
                ...restPayload,
                updateDealLifecycleStatus: enableDealLifeCycleUpdates
                    ? UpdateDealLifecycleStatus.Success
                    : UpdateDealLifecycleStatus.Ready
            };
        }

        case UPDATE_DEAL_LIFE_CYCLE_REQUEST: {
            return {
                ...state,
                updateDealLifecycleStatus: UpdateDealLifecycleStatus.Sending
            };
        }

        case UPDATE_DEAL_LIFE_CYCLE_FAILURE: {
            return {
                ...state,
                updateDealLifecycleStatus: UpdateDealLifecycleStatus.Failure
            };
        }

        case UPDATE_DEAL_LIFE_CYCLE_READY: {
            return {
                ...state,
                updateDealLifecycleStatus: UpdateDealLifecycleStatus.Ready
            };
        }

        case SHOW_DEAL_LIFE_CYCLE_MODAL: {
            return {
                ...state,
                showDealLifeCycleModal: action.payload.showDealLifeCycleModal
            };
        }
        case SET_DEAL_LIFE_CYCLE_MODAL_LOADER: {
            return {
                ...state,
                showDealLifeCycleModalLoader: action.payload.showDealLifeCycleModalLoader
            };
        }
        case SOCKET_EVENT_RECEIVED: {
            if (action.payload.hasContractSignDateUpdated) {
                const rawContractSignedDate = action.payload.data?.dealLifecycle?.contractSignedDate;
                const normalizedContractSignedDate =
                    rawContractSignedDate && dateUtils.formatAsMMDDYYYY(new Date(rawContractSignedDate));
                return {
                    ...state,
                    ...action.payload.data.dealLifecycle,
                    status: rawContractSignedDate && 'Sold',
                    soldDate: action.payload.data.dealLifecycle.soldDate || new Date().toISOString(),
                    contractSignedDate: normalizedContractSignedDate,
                    hasContractSignDateUpdated: true
                };
            }
            return {
                ...state,
                hasContractSignDateUpdated: false
            };
        }

        default: {
            return state;
        }
    }
};
